import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import { merge } from 'lodash';
import React from 'react';
import { Container } from 'react-bootstrap';
import { StorageContentBlock } from '../common/StorageContentBlock/StorageContentBlock';
import ImgContentImage from './components/ImgContentImage';
import { imageContentStyles } from './styles';
import { DefaultSettings } from './types';

interface StorageImageContentProps {
  node: IStorageImageContent;
}

const StorageImageContent: React.FC<StorageImageContentProps> = function ({ node: imageContent }) {
  const settings = merge({}, DefaultSettings, imageContent?.behaviors);
  const node = { ...imageContent, behaviors: settings };

  const cmsTheme = settings.entity_variant.theme;
  const media_image = imageContent?.relationships?.image;

  const styleSettings = {
    color: cmsTheme,
    contentPosition: settings.entity_variant.content_position,
    verticalAlignment: settings.entity_variant.vertical_alignment,
  };

  const loadingStrategy = settings.entity_variant.load_eagerly ? 'eager' : 'lazy';

  const handleGA = () => {
    const hasSecondaryButton = imageContent.links?.length! > 1;
    const primaryTitle = imageContent.links?.[0]?.title ?? '[not set]';
    const secondaryTitle = imageContent?.links?.[1]?.title ?? '[not set]';
    sendIt({
      event: 'module_interaction',
      eventParams: {
        component_id: hasSecondaryButton
          ? `primary_cta: ${primaryTitle},  secondary_cta: ${secondaryTitle}`
          : `primary_cta: ${primaryTitle}`,
        component_type: 'image_content_link',
        content_name: imageContent?.title,
      },
    });
  };

  const { wrapper, heading, imgContainer } = imageContentStyles(styleSettings);
  return (
    <Container
      id={imageContent.component_id}
      data-id={imageContent.drupal_id}
      className={imgContainer()}
      fluid
    >
      <Container>
        <div className={wrapper({ className: 'pds-flex pds-flex-wrap pds-gap-5 md:pds-gap-6' })}>
          <ImgContentImage
            loadingStrategy={loadingStrategy}
            media_image={media_image}
            styleSettings={styleSettings}
          />
          <div className={heading({ className: 'pds-flex pds-w-full pds-flex-col md:pds-w-1/2' })}>
            <StorageContentBlock node={node} actionCallback={handleGA} />
          </div>
        </div>
      </Container>
    </Container>
  );
};

export default StorageImageContent;
